import React from "react";
import { fmt, fmtPrecoUnit, STATUS_COR, STATUS_LABEL } from "../constants";

export default function AbaNotasFiscais({ dados }) {
  const {
    buscaNF, setBuscaNF, importarXML, loading, pedidosFiltrados,
    aberto, setAberto, excluirNF,
  } = dados;

  return (
    <>
      <div className="page-toolbar">
        <button className="btn btn-primary" onClick={()=>document.getElementById("xml-input").click()}>
          <i className="ti ti-upload"/> Importar XML
        </button>
        <input id="xml-input" type="file" accept=".xml,.XML" multiple style={{display:"none"}} onChange={importarXML}/>
        <input className="form-input" style={{width:250}} placeholder="Buscar fornecedor ou NF..." value={buscaNF} onChange={e=>setBuscaNF(e.target.value)}/>
      </div>
      <div className="card">
        <div className="table-wrapper">
          {loading?<div className="table-empty">Carregando...</div>:
          !pedidosFiltrados.length?<div className="table-empty">Nenhuma NF encontrada.</div>:
          <table>
            <thead><tr>
              <th>NF</th><th>Fornecedor</th><th>Data</th><th>Vencimento</th>
              <th className="td-r">Total</th><th>Status</th><th></th>
            </tr></thead>
            <tbody>
              {pedidosFiltrados.map(p=>{
                const open=aberto===("nf-"+p.id);
                return(
                  <React.Fragment key={p.id}>
                    <tr className="tr-expandable" onClick={()=>setAberto(open?null:("nf-"+p.id))}>
                      <td style={{fontFamily:"monospace"}}>{p.numero_nf} <span style={{fontSize:10,color:"var(--z-text-muted)"}}>s{p.serie}</span></td>
                      <td><strong>{p.fornecedor_nome}</strong></td>
                      <td className="fs-13 text-secondary">{p.data_emissao?new Date(p.data_emissao+"T12:00:00").toLocaleDateString("pt-BR"):"—"}</td>
                      <td className="fs-13 text-secondary">{p.data_vencimento?new Date(p.data_vencimento+"T12:00:00").toLocaleDateString("pt-BR"):"—"}</td>
                      <td style={{textAlign:"right",fontWeight:600}}>R$ {fmt(p.valor_total)}</td>
                      <td><span style={{color:STATUS_COR[p.status],fontWeight:600,fontSize:12}}>{STATUS_LABEL[p.status]}</span></td>
                      <td className="td-r">
                        <button className="btn btn-danger" style={{fontSize:11,padding:"2px 8px"}} onClick={e=>{e.stopPropagation();excluirNF(p.id);}}>Excluir</button>
                      </td>
                    </tr>
                    {open&&(
                      <tr className="tr-dropdown">
                        <td colSpan={7}>
                          <div className="p-dropdown">
                            <div style={{display:"flex",gap:24,fontSize:13,marginBottom:8}}>
                              <span>Produtos: <strong>R$ {fmt(p.valor_produtos)}</strong></span>
                              <span>Frete: <strong>R$ {fmt(p.frete)}</strong></span>
                              <span>Total: <strong className="text-blue">R$ {fmt(p.valor_total)}</strong></span>
                            </div>
                            <table style={{width:"100%",fontSize:12}}>
                              <thead><tr className="bg-page">
                                <th className="td-l">Cod XML</th>
                                <th className="td-l">Descricao</th>
                                <th className="td-l">Vinculado a</th>
                                <th className="td-r">Qtd</th>
                                <th className="td-r">Valor Unit</th>
                                <th className="td-r">Total</th>
                              </tr></thead>
                              <tbody>
                                {(p.itens||[]).map(it=>(
                                  <tr key={it.id} style={{borderBottom:"1px solid var(--z-border)"}}>
                                    <td className="td-mono">{it.cod_xml}</td>
                                    <td style={{padding:"4px 8px",fontSize:12}}>{it.nome_xml}</td>
                                    <td className="td-p">
                                      {it.produto
                                        ?<span style={{color:"var(--z-success-text)",fontSize:11,fontWeight:600}}>{it.produto_codigo} — {it.produto_nome}</span>
                                        :<span style={{color:"var(--z-danger-text)",fontSize:11}}>Nao vinculado</span>
                                      }
                                    </td>
                                    <td className="td-r-sm">{fmt(it.quantidade)} {it.unidade}</td>
                                    <td className="td-r-sm">{fmtPrecoUnit(it.valor_unit,it.unidade)}</td>
                                    <td style={{padding:"4px 8px",textAlign:"right",fontWeight:600}}>R$ {fmt(it.valor_total)}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>}
        </div>
      </div>
    </>
  );
}
